// EIN helpers, shared by the contact step (input + validation) and anywhere
// else that needs to display or check a federal tax ID.
export const EIN_REGEX = /^\d{2}-\d{7}$/;

export function formatEIN(raw) {
  // Strip everything except digits, limit to 9 digits, then insert dash after position 2.
  const digits = raw.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}
